var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54 2.874a.65.65 0 0 1 .92 0l4.666 4.666a.65.65 0 0 1-.919.92L8.65 4.903v7.764a.65.65 0 1 1-1.3 0V4.903L3.793 8.46a.65.65 0 0 1-.92-.92L7.54 2.874Z",
    fill: "currentColor"
  })));
};

export { Svg16 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjU0MDQgMi44NzM3MUM3Ljc5NDI0IDIuNjE5ODcgOC4yMDU3OSAyLjYxOTg3IDguNDU5NjQgMi44NzM3MUwxMy4xMjYzIDcuNTQwMzhDMTMuMzgwMSA3Ljc5NDIyIDEzLjM4MDEgOC4yMDU3OCAxMy4xMjYzIDguNDU5NjJDMTIuODcyNSA4LjcxMzQ2IDEyLjQ2MDkgOC43MTM0NiAxMi4yMDcxIDguNDU5NjJMOC42NTAwMiA0LjkwMjU3TDguNjUwMDIgMTIuNjY2N0M4LjY1MDAyIDEzLjAyNTcgOC4zNTkgMTMuMzE2NyA4LjAwMDAyIDEzLjMxNjdDNy42NDEwMyAxMy4zMTY3IDcuMzUwMDIgMTMuMDI1NyA3LjM1MDAyIDEyLjY2NjdMNy4zNTAwMiA0LjkwMjU3TDMuNzkyOTcgOC40NTk2MkMzLjUzOTEzIDguNzEzNDYgMy4xMjc1NyA4LjcxMzQ2IDIuODczNzMgOC40NTk2MkMyLjYxOTg5IDguMjA1NzggMi42MTk4OSA3Ljc5NDIyIDIuODczNzMgNy41NDAzOEw3LjU0MDQgMi44NzM3MVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";